export const formatNumber = (number: number, minimumFractionDigits = 2, maximumFractionDigits = 5): string => {
  const formatter = new Intl.NumberFormat('en-US', {
    minimumFractionDigits,
    maximumFractionDigits
  });

  return formatter.format(number);
};
